<template>
  <v-flex lg4>
    <v-select
      v-model="selectedLocation"
      :items="locations"
      class="vbt-hide-form-control-details"
      dark
    />
  </v-flex>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import { namespace as LocationsNamespace, MutationTypes as LocationsMutationTypes } from '@store/modules/locations.types';

export default {
  name: 'LocationSelector',
  computed: {
    ...mapState(LocationsNamespace, {
      suffix: ({ suffix }) => suffix,
      locations: ({ locations }) => locations
        .map(({ name: text, suffix: value }) => ({ text, value })),
    }),
    selectedLocation: {
      get() {
        return this.suffix;
      },
      set(newValue) {
        if (newValue !== this.suffix) {
          this.updateLocationSuffix(newValue);
        }
      },
    },
  },
  watch: {
    '$route.query.suffix'(newValue) { //eslint-disable-line
      if (newValue !== this.suffix) {
        this.updateLocationSuffix(newValue || this.suffix);
      }
    },
  },
  methods: {
    ...mapMutations(LocationsNamespace, {
      updateLocationSuffix(commit, suffix) {
        commit(LocationsMutationTypes.SET_SUFFIX, suffix);

        const { meta = {}, query } = this.$route;
        let to;

        if (meta.parent) {
          to = { ...meta.parent.to };
          to.query.suffix = suffix;
          this.$router.push(to);
          return;
        }

        to = {
          suffix,
          pageNum: query.pageNum ? '1' : undefined,
        };

        this.$router.push({ query: to }, null, () => {});
      },
    }),
  },
};
</script>
